@if (isIndividualActive) {
  <div class="container py-4 pe-4">
    <section class="row align-items-center">
      <div class="mobile-title col-md-6 col-sm-12 col-12">
        <h2 class="title">{{ 'insights.welcome' | translate }}, {{ name + ' ' + surname }}!</h2>
      </div>
      <div
        class="col-md-6 col-sm-12 d-flex justify-content-md-end justify-content-sm-between align-items-center toggle-and-date">
        <div class="toggle-container d-flex me-md-3">
          <button class="toggle-button" [class.active]="isIndividualActive" (click)="toggleIndividual(true)">
            <img src="assets/svg/person.svg" alt="Individual Icon">
            <span class="mx-2">{{ 'insights.individual' | translate }}</span>
          </button>
          @if (isCurrentUserOwnerOfTeam) {
            <button class="toggle-button" [class.active]="!isIndividualActive" (click)="toggleIndividual(false)">
              <img src="assets/svg/group.svg" alt="Group Icon">
              <span class="mx-2">{{ 'insights.my_team' | translate }}</span>
            </button>
          }
        </div>
        @if (!isMobile) {
          <div class="custom-date-range-container">
            <mat-form-field class="custom-date-range" appearance="outline">
              <input matInput [readonly]="true" [value]="displayDateRange || ('insights.date' | translate)" placeholder="{{ 'insights.date' | translate }}"/>
              <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRange" class="d-none" [max]="today">
                <input matStartDate formControlName="start">
                <input matEndDate formControlName="end">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker>
                <mat-date-range-picker-actions>
                  <button mat-button class="button-size-16" (click)="resetDateRange(picker)">{{ 'insights.reset' | translate }}</button>
                  <button mat-button class="button-size-16" matDateRangePickerApply (click)="onDateRangeChange()">{{ 'insights.ok' | translate }}
                  </button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>
        }
      </div>
    </section>

    <div class="row mt-3">
      <div class="col-md-4 col-lg-4 col-sm-12 col-12">
        <mat-card class="card-container" appearance="outlined">
          <mat-card-content>
            <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.link_taps' | translate }}
            </span>
            </div>
            <div class="statistic">
              <span class="total-count">{{ contentStat?.totalLinkTapsCount }}</span>
              <span
                class="percent-value">{{ contentStat?.monthlyLinkTapsPercent != null && contentStat.monthlyLinkTapsPercent > 0 ? ('+' + (contentStat?.monthlyLinkTapsPercent | number:'1.2-2') + '%') : (contentStat?.monthlyLinkTapsPercent | number:'1.2-2') + '%' }}</span>
            </div>
            <div class="tooltip-info">{{ 'insights.link_taps_description' | translate }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-12">
        <mat-card class="card-container" appearance="outlined">
          <mat-card-content>
            <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.card_views' | translate }}
            </span>
            </div>
            <div class="statistic">
              <span class="total-count">{{ cardViewStat?.totalViewCount }}</span>
              <span
                class="percent-value">{{ cardViewStat?.monthlyPercent != null && cardViewStat.monthlyPercent > 0 ? ('+' + (cardViewStat.monthlyPercent |number:'1.2-2') + '%') : (cardViewStat?.monthlyPercent | number:'1.2-2') + '%' }}</span>
            </div>
            <div class="tooltip-info">{{ 'insights.card_views_description' | translate }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-12">
        <mat-card class="card-container" appearance="outlined">
          <mat-card-content>
            <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.contacts_downloaded' | translate }}
            </span>
            </div>
            <div class="statistic">
              <span class="total-count">{{ downloadedStat?.totalDownloadedCount }}</span>
              <span
                class="percent-value">{{ downloadedStat?.monthlyDownloadedPercent != null && downloadedStat.monthlyDownloadedPercent > 0 ? ('+' + ( downloadedStat?.monthlyDownloadedPercent | number:'1.2-2') + '%') : (downloadedStat?.monthlyDownloadedPercent | number:'1.2-2') + '%' }}</span>
            </div>
            <div class="tooltip-info">{{ 'insights.contacts_downloaded_description' | translate }}</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <mat-card class="mt-4 custom-card">
      <mat-card-content>
      <span class="card-info d-flex align-items-center">
        {{ 'insights.link_taps' | translate }}
      </span>
        <p-table class="transaction-table mt-4"
                 [value]="linkTapData || []"
                 [tableStyle]="{'min-width': '60rem'}"
                 [rowHover]="true"
                 [resizableColumns]="true"
                 [rows]="10"
                 [sortOrder]="-1"
                 sortField="id">
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn>{{ 'insights.link' | translate }}</th>
              <th pResizableColumn>{{ 'insights.username' | translate }}</th>
              <th pResizableColumn>{{ 'insights.card_name' | translate }}</th>
              <th pResizableColumn pSortableColumn="tapCount">
                {{ 'insights.taps' | translate }}
                <p-sortIcon field="tapCount"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr class="desktop-row">
              <td>
              <span>
               <img
                 [src]="row.userCardContentResponse.content.contentIcon ? getContentIcon(row.userCardContentResponse.content.contentIcon) : ''"
                 class="content-icon-frame me-3" alt=""> {{ row.userCardContentResponse.content.name }}
                  </span>
              </td>
              <td>
             <span><span class="table-card-label">{{ 'insights.card_name' | translate }}<br></span>
               {{ row.userCardResponse.cardId }}
             </span>
              </td>
              <td class="bg-white">
             <span class="cursor-pointer">
               <span class="table-card-label">{{ 'insights.username' | translate }}<br></span>
               {{ row.userCardResponse.name }} {{ row.userCardResponse.surname }}
             </span>
              </td>
              <td>
             <span><span class="table-card-label">{{ 'insights.taps' | translate }}<br></span>
               {{ row.tapCount }}
             </span>
              </td>
            </tr>
            <tr class="mobile-row">
              <td colspan="4">
                <div class="mobile-card">
                  <div class="icon-section">
                    <img
                      [src]="row.userCardContentResponse.content.contentIcon ? getContentIcon(row.userCardContentResponse.content.contentIcon) : ''"
                      class="content-icon-frame me-3" alt="">
                  </div>
                  <div class="details-section">
                    <label class="table-card-label">{{ 'insights.card_name' | translate }}</label><br>
                    {{ row.userCardResponse.name }} {{ row.userCardResponse.surname }}
                    <div class="d-flex justify-content-between">
                      <p>
                        <label class="table-card-label">{{ 'insights.username' | translate }}</label><br>
                        {{ row.userCardResponse.cardId }}
                      </p>
                      <p>
                        <label class="table-card-label">{{ 'insights.taps' | translate }}</label><br>
                        {{ row.tapCount }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-light-gray fs-15">{{ 'insights.message' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </mat-card-content>
    </mat-card>

  </div>
}

<div class="container py-4 pe-4" [style.display]="!isIndividualActive ? 'block' : 'none'">
  <section class="row align-items-center">
    <div class="mobile-title col-md-6 col-sm-12 col-12">
      <h2 class="title">{{ 'insights.welcome' | translate }}, {{ name + ' ' + surname }}!</h2>
    </div>
    <div
      class="col-md-6 col-sm-12 d-flex justify-content-md-end justify-content-sm-between align-items-center toggle-and-date">
      <div class="toggle-container d-flex me-md-3">
        <button class="toggle-button" [class.active]="isIndividualActive" (click)="toggleIndividual(true)">
          <img src="assets/svg/person.svg" alt="Individual Icon">
          <span class="mx-2">{{ 'insights.individual' | translate }}</span>
        </button>
        <button class="toggle-button" [class.active]="!isIndividualActive" (click)="toggleIndividual(false)">
          <img src="assets/svg/group.svg" alt="Group Icon">
          <span class="mx-2">{{ 'insights.my_team' | translate }}</span>
        </button>
      </div>
      @if (!isMobile) {
        <div class="custom-date-range-container">
          <mat-form-field class="custom-date-range" appearance="outline">
            <input matInput [readonly]="true" [value]="displayDateRange || ('insights.date' | translate)" placeholder="{{ 'insights.date' | translate }}"/>
            <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRange" class="d-none" [max]="today">
              <input matStartDate formControlName="start">
              <input matEndDate formControlName="end">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
              <mat-date-range-picker-actions>
                <button mat-button class="button-size-16" (click)="resetDateRange(picker)">{{ 'insights.reset' | translate }}</button>
                <button mat-button class="button-size-16" matDateRangePickerApply (click)="onDateRangeChange()">{{ 'insights.ok' | translate }}
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div>
      }
    </div>
  </section>
  <div class="row mt-3">
    <div class="col-md-4 col-lg-4 col-sm-12 col-12">
      <mat-card class="card-container" appearance="outlined">
        <mat-card-content>
          <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.link_taps' | translate }}
            </span>
          </div>
          <div class="statistic">
            <span class="total-count">{{ contentStat?.totalLinkTapsCount }}</span>
            <span
              class="percent-value">{{ contentStat?.monthlyLinkTapsPercent != null && contentStat.monthlyLinkTapsPercent > 0 ? ('+' + ( contentStat?.monthlyLinkTapsPercent | number:'1.2-2') + '%') : ( contentStat?.monthlyLinkTapsPercent | number:'1.2-2') + '%' }}</span>
          </div>
          <div class="tooltip-info">{{ 'insights.link_taps_description' | translate }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-4 col-lg-4 col-sm-12 col-12">
      <mat-card class="card-container" appearance="outlined">
        <mat-card-content>
          <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.card_views' | translate }}
            </span>
          </div>
          <div class="statistic">
            <span class="total-count">{{ cardViewStat?.totalViewCount }}</span>
            <span
              class="percent-value">{{ cardViewStat?.monthlyPercent != null && cardViewStat.monthlyPercent > 0 ? ('+' + ( cardViewStat.monthlyPercent | number:'1.2-2') + '%') : ( cardViewStat?.monthlyPercent| number:'1.2-2') + '%' }}</span>
          </div>
          <div class="tooltip-info">{{ 'insights.card_views_description' | translate }}</div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-4 col-lg-4 col-sm-12 col-12">
      <mat-card class="card-container" appearance="outlined">
        <mat-card-content>
          <div class="d-flex justify-content-between">
            <span class="card-info d-flex align-items-center">
              {{ 'insights.contacts_downloaded' | translate }}
            </span>
          </div>
          <div class="statistic">
            <span class="total-count">{{ downloadedStat?.totalDownloadedCount }}</span>
            <span
              class="percent-value">{{ downloadedStat.monthlyDownloadedPercent != null && downloadedStat.monthlyDownloadedPercent > 0 ? ('+' + ( downloadedStat.monthlyDownloadedPercent | number:'1.2-2') + '%') : ( downloadedStat.monthlyDownloadedPercent| number:'1.2-2') + '%' }}</span>
          </div>
          <div class="tooltip-info">{{ 'insights.contacts_downloaded_description' | translate }}</div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="d-flex justify-content-between col-sm-12 justify-content-md-end justify-content-sm-between toggle-and-date">
    <mat-card class="mt-4 custom-card col-md-6 col-sm-12 card-spacing">
      <mat-card-content>
          <span class="card-info d-flex align-items-center ">
            {{ 'insights.top_performers' | translate }}
          </span>
        <div class="tooltip-info">{{ 'insights.top_performers_description' | translate }}</div>
        <div class="canvas-section" [style.display]="topUsers.length==0 ? 'none' : 'block'"
             id="chartContainer">
          <canvas id="topPerformersChart" class="canvas-section max-w-800px"></canvas>
        </div>
        @if (topUsers.length == 0) {
          <span class="text-center d-flex align-items-center mt-4 text-light-gray canvas-section">{{ 'insights.no_top_performers_data' | translate }}</span>
        }
      </mat-card-content>
    </mat-card>
    <mat-card class="mt-4 custom-card col-md-6 col-sm-12 card-spacing">
      <mat-card-content>
      <span class="card-info d-flex align-items-center">
        {{ 'insights.my_link_taps' | translate }}
      </span>
        <div class="tooltip-info">{{ 'insights.my_link_taps_description' | translate }}</div>
        <p-table class="transaction-table mt-4"
                 [value]="linkTapData || []"
                 [rowHover]="true"
                 [rows]="10"
                 [sortOrder]="-1"
                 sortField="id">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'insights.link' | translate }}</th>
              <th>{{ 'insights.username' | translate }}</th>
              <th pSortableColumn="tapCount">
                {{ 'insights.taps' | translate }}
                <p-sortIcon field="tapCount"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr class="desktop-row">
              <td>
              <span>
               <img
                 [src]="row.userCardContentResponse.content.contentIcon ? getContentIcon(row.userCardContentResponse.content.contentIcon) : ''"
                 class="content-icon-frame me-3" alt=""> {{ row.userCardContentResponse.content.name }}
                  </span>
              </td>
              <td>
             <span><span class="table-card-label">{{ 'insights.username' | translate }}<br></span>
               {{ row.userCardResponse.cardId }}
             </span>
              </td>

              <td>
             <span><span class="table-card-label">{{ 'insights.taps' | translate }}<br></span>
               {{ row.tapCount }}
             </span>
              </td>
            </tr>
            <tr class="mobile-row">
              <td colspan="4">
                <div class="mobile-card">
                  <div class="icon-section">
                    <img
                      [src]="row.userCardContentResponse.content.contentIcon ? getContentIcon(row.userCardContentResponse.content.contentIcon) : ''"
                      class="content-icon-frame me-3" alt="">
                  </div>
                  <div class="details-section">
                    <label class="table-card-label">{{ 'insights.card_name' | translate }}</label><br>
                    {{ row.userCardResponse.name }} {{ row.userCardResponse.surname }}
                    <div class="d-flex justify-content-between">
                      <p>
                        <label class="table-card-label">{{ 'insights.username' | translate }}</label><br>
                        {{ row.userCardResponse.cardId }}
                      </p>
                      <p>
                        <label class="table-card-label">{{ 'insights.taps' | translate }}</label><br>
                        {{ row.tapCount }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-light-gray fs-15">{{ 'insights.message' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div class="common-footer">
  @if (isMobile){<div class="custom-date-range-container-mobile ">
     <mat-form-field class="custom-date-range w-100" appearance="outline">
      <input matInput [readonly]="true"  [value]="displayDateRange || ('insights.date' | translate)" placeholder="{{ 'insights.date' | translate }}" />
      <mat-date-range-input [rangePicker]="picker1" [formGroup]="dateRange" class="d-none" [max]="today" >
        <input matStartDate formControlName="start">
        <input matEndDate formControlName="end">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-date-range-picker #picker1>
        <mat-date-range-picker-actions>
          <button mat-button class="button-size-16" (click)="resetDateRange(picker1)">{{ 'insights.reset' | translate }}</button>
          <button mat-button class="button-size-16" matDateRangePickerApply (click)="onDateRangeChange()">{{ 'insights.ok' | translate }}</button>
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>
  </div>
  }
</div>
